exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sales-header[data-v-4a649972] {\n  font-weight: 500;\n  font-size: 12px;\n}\na.sales-sort[data-v-4a649972] {\n  color: #4c5669;\n}\na.sales-sort.selected[data-v-4a649972] {\n  color: #2962ff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a649972","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reports/sales/SalesTableHeader.vue
// module id = omZR
// module chunks = 0